import Container from 'components/Container'
import styled from 'styled-components'

const VideoContainer = styled(Container)`
	display: flex;
	overflow: hidden;
`

export default { VideoContainer }
